<template>
  <CSidebar
    position="fixed"
    class="bg-theme-white theme-rounded-sidebar pb-0 px-0"
    :unfoldable="sidebarUnfoldable"
    :visible="sidebarVisible"
    @visible-change="
      (event) =>
        $store.commit({
          type: 'updateSidebarVisible',
          value: event,
        })
    "
  >
    <CSidebarBrand class="bg-transparent my-2 mb-0 theme-rounded-sidebar-top shadow">
      <div class="bg-theme-white theme-rounded-sidebar-top">
        <CImage
          class="sidebar-brand-full m-4"
          :src="LongLogo"
          :height="80"
        />
        <CImage
          class="sidebar-brand-narrow"
          :src="ShortLogo"
          :height="50"
        />
      </div>
    </CSidebarBrand>
    <AppSidebarNav class="d-flex justify-content-center bg-theme-white shadow theme-rounded-sidebar-bottom py-3" />

    <!-- Logout Button -->
    <CSidebarBrand class="bg-transparent d-block theme-rounded-sidebar-bottom mb-2">
      <div class="sidebar-brand-full m-3 position-relative">
        <CButton color="danger" class="bg-theme-danger text-white theme-rounded-full py-2 text-center w-100 shadow" @click="logOut()">
          <div class="position-absolute bg-white text-theme-danger sidebar-logout-icon-wrapper">
            <CIcon icon="cil-account-logout" /> 
          </div>
          Logout
        </CButton>
      </div>
      <div class="sidebar-brand-narrow pt-3">
          <CButton class="bg-theme-danger text-theme-white sidebar-logout-icon-wrapper mx-auto shadow">
            <CIcon icon="cil-account-logout" size="lg" /> 
          </CButton>
      </div>
    </CSidebarBrand>

    <!-- <CSidebarToggler
      class="d-none d-lg-flex bg-theme-dark"
      @click="$store.commit('toggleUnfoldable')"
    /> -->
  </CSidebar>
</template>

<script>
import { computed } from 'vue'
import { useStore } from 'vuex'
import { AppSidebarNav } from './AppSidebarNav'
import { logoNegative } from '@/assets/brand/logo-negative'
import { sygnet } from '@/assets/brand/sygnet'
import { brandSet } from '@coreui/icons'
import Logos from '@/assets/brand/index'
export default {
  name: 'AppSidebar',
  components: {
    AppSidebarNav,
  },
  setup() {
    const store = useStore()
    const icons = brandSet
    return {
      logoNegative,
      sygnet,
      icons,
      ShortLogo: Logos.ShortLogoSVG,
      LongLogo: Logos.LongLogoSVG,
      sidebarUnfoldable: computed(() => store.state.sidebarUnfoldable),
      sidebarVisible: computed(() => store.state.sidebarVisible),
      sidebarNarrow: computed(() => store.state.sidebarNarrow),
    }
  },
  methods: {
    logOut() {
      this.$store.dispatch('auth/logout')
      this.$router.push('/login')
    }
  }
}
</script>

<style lang="scss">

</style>
